import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana95Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1461_7439)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M412.876 522.688L399.291 489.478L458.163 460.797L476.277 500.045L429.481 524.198C422.236 527.82 415.392 524.701 412.876 522.688Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M533.642 472.875L476.28 500.047L458.165 460.799L515.528 433.627L533.642 472.875Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M591.003 444.189L533.64 472.871L515.526 433.623L572.888 404.941L591.003 444.189Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M633.274 424.568L591.007 444.192L572.892 404.944L649.879 368.715L633.274 424.568Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M384.199 457.78L399.294 489.48L453.635 463.818L434.011 420.041L387.218 442.684C382.387 447.515 383.192 454.76 384.199 457.78Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M486.845 395.891L434.011 420.043L453.635 463.82L506.469 438.158L486.845 395.891Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M541.192 370.229L486.849 395.891L506.473 438.158L560.816 410.986L541.192 370.229Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M595.531 344.561L541.188 370.223L560.812 410.98L613.645 385.318L595.531 344.561Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M642.327 321.92L595.531 344.563L613.646 385.321L649.875 368.716L662.216 333.063C663.031 330.709 663.376 328.091 662.258 325.865C658.238 317.857 647.676 319.691 642.327 321.92Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1461_7439" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1461_7439" transform="matrix(0.00207059 0 0 0.00274504 -4.40436 -2.1555)"/>
    </pattern>
    <image id="image0_1461_7439" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};